import { useCallback } from 'react';
import styled, { keyframes } from 'styled-components';

// Define a keyframe animation for blinking

const blink = keyframes`
    to {
        visibility: hidden;
    }
`;

// Styled components for the wrapper, button, and pill badge

const Wrapper = styled.div`
    position: fixed;
    bottom: 2%;
    left: 2%;
`;

const Button = styled.button`
    border-radius: 4px;
    padding: 0px !important;
    font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    text-decoration: none;
    position: relative !important;
    margin: 0px 16px;
    cursor: pointer;
    background: none !important;
    outline: none !important;
    border: none !important;
`;

const PillBadge = styled.span`
    position: absolute !important;
    top: 20px;
    left: 80% !important;
    transform: translate(-50%, -50%) !important;
    background-color: #dc3545 !important;
    display: inline-block;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    color: #fff;
    padding: 2px 4px;
    font-size: 10px;
    border-radius: 100px;
    font-weight: bold;
    animation: ${blink} 2s steps(5, start) infinite !important;
    -webkit-animation: ${blink} 1s steps(5, start) infinite !important;
`;

// Functional component for email count button
const EmailCountButton = () => {
    // Callback function to open email link
    const openEmail = useCallback(() => {
        window.open('https://web.phone.email', '_blank');
    }, []);

    // Render the button with pill badge inside the wrapper
    return (
        <Wrapper>
            <Button onClick={openEmail}>
                <svg width="62" height="62" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="31" cy="31" r="26" fill="#4CAF50" />
                    <circle cx="31" cy="31" r="31" fill="#4CAF50" fillOpacity="0.5" />
                    <path d="M18.3077 21C17.8541 21 17.4377 21.1363 17.0817 21.3606L30.0625 32.9231C30.6466 33.4438 31.3785 33.4438 31.9615 32.9231L44.9183 21.3606C44.5623 21.1363 44.1459 21 43.6923 21H18.3077ZM16.1322 22.5625C16.0523 22.7971 16 23.0453 16 23.3077V38.6923C16 39.1496 16.1329 39.5725 16.3606 39.9303L25.6274 31.0361L16.1322 22.5625ZM45.8678 22.5625L36.3966 31.024L45.6274 39.9423C45.8607 39.5815 46 39.1557 46 38.6923V23.3077C46 23.0453 45.9477 22.7971 45.8678 22.5625ZM35.2428 32.0577L32.9832 34.0769C31.8581 35.0817 30.1663 35.0803 29.0408 34.0769L26.7812 32.0697L17.5985 40.8798C17.8229 40.9522 18.0587 41 18.3077 41H43.6923C43.9413 41 44.1771 40.9522 44.4015 40.8798L35.2428 32.0577Z" fill="white" />
                </svg>
                <PillBadge>9+</PillBadge>
            </Button>
        </Wrapper>
    );
}

export default EmailCountButton;
